/* @flow */
import * as React from 'react';
import ReactDOMServer from 'react-dom/server';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import striptags from 'striptags';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import Loading from 'components/Loading/Loading';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ElectroMessageBarCont from 'forms/components/inputs/ElectroMessageBarCont/ElectroMessageBarCont';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  location: Object,
  form: TypeForm,
  accountStore: Object,
|} & TranslatorProps;

@translate()
@inject('accountStore')
@observer
export default class ArchiveLocationForm extends React.Component<*> {
  render(): React.Node {
    const { t, location, form, accountStore }: TypeProps = this.props;

    const locationDetails: Object = location.hierarchy ? location : accountStore.locationDetails;

    let details: Array<*> = [];

    if (locationDetails) {
      details = [
        [
          t('general:company'),
          locationDetails.company ? locationDetails.company.name : locationDetails.company_name,
        ],
      ];

      if (locationDetails.hierarchy.site) {
        if (locationDetails.hierarchy.site.name) {
          details.push([t('general:locations.labels.site'), locationDetails.hierarchy.site.name]);
        }

        if (locationDetails.hierarchy.site.address) {
          details.push([
            t('general:locations.labels.site_address'),
            striptags(
              ReactDOMServer.renderToString(
                <SiteAddress key="site_address" {...locationDetails.hierarchy.site.address} />
              )
            ),
          ]);
        }
      }

      if (locationDetails.hierarchy.building && locationDetails.hierarchy.building.name) {
        details.push([
          t('general:locations.labels.building_transport'),
          locationDetails.hierarchy.building.name,
        ]);
      }

      if (locationDetails.hierarchy.room && locationDetails.hierarchy.room.name) {
        details.push([t('general:locations.labels.lab_room'), locationDetails.hierarchy.room.name]);
      }

      if (locationDetails.hierarchy.workspace && locationDetails.hierarchy.workspace.name) {
        details.push([
          t('general:locations.labels.system_workspace'),
          locationDetails.hierarchy.workspace.name,
        ]);
      }
    }

    if (!accountStore.locationDetails) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:locations.labels.details')}
          >
            <ActionDrawerTable data={details} />
            {locationDetails.all_assets_count > 0 && (
              <ElectroMessageBarCont
                props={{
                  linkto: `/assets/location/${locationDetails.id}`,
                  variant: 'warning',
                  message: t('general:assets.still_assigned', {
                    count: locationDetails.all_assets_count,
                  }),
                }}
              />
            )}
            {locationDetails.all_projects_count > 0 && (
              <ElectroMessageBarCont
                props={{
                  linkto: `/projects/location/${locationDetails.id}`,
                  variant: 'warning',
                  message: t('general:projects.messages.still_assigned', {
                    count: locationDetails.all_projects_count,
                  }),
                }}
              />
            )}
          </ActionDrawerBlock>
          {locationDetails.all_assets_count === 0 && locationDetails.all_projects_count === 0 && (
            <ActionDrawerBlock gutters={true} heading={form.$('archiveReason').label}>
              <ElectroSelectWithOther
                field={form.$('archiveReason.reason')}
                otherHeading={`${t('general:reasons.provide_reason')} *`}
              />
            </ActionDrawerBlock>
          )}
        </div>
        <ActionDrawerFormButtons
          form={form}
          submitTxt={t('general:actions.archive_location')}
          disabled={locationDetails.all_assets_count > 0 || locationDetails.all_projects_count > 0}
        />
      </React.Fragment>
    );
  }
}
